import throttle from 'lodash/throttle';

export default {
  methods: {
    apply(options, { method = 'throttle', delay = 300 } = {}) {
      if (method === 'throttle') {
        this.applyFiltersThrottle(options);
      }
      if (method === 'debounce') {
        if (this.debouncedFunction) {
          clearTimeout(this.debouncedFunction);
        }
        this.debouncedFunction = this.applyFiltersDebounce(options, delay);
      }
    },
    applyFiltersThrottle: throttle(async function ({ name, value }) { // eslint-disable-line func-names
      await this.$store.dispatch('applyFilters', {
        changedFilter: name,
        value,
      });
    }, 300),
    applyFiltersDebounce({ name, value }, delay) {
      return setTimeout(async () => {
        this.debouncedFunction = null;
        await this.$store.dispatch('applyFilters', {
          changedFilter: name,
          value,
        });
      }, delay);
    },
  },
};
